// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__31mph","modal":"Modal_modal__1BCFj","slide-down":"Modal_slide-down__2gflz"};